import { Box, MultiSelect, MultiSelectProps } from '@mantine/core';
import ColoredMessage from '../ColoredMessage/ColoredMessage';

export const ManifestMultiselect = (props: MultiSelectProps) => {
  return (
    <MultiSelect
      {...props}
      error={
        props.error ? (
          <Box mt={8}>
            <ColoredMessage message={props.error} />
          </Box>
        ) : undefined
      }
    />
  );
};
